class limespotProductsBox extends HTMLElement {
  constructor() {
    super();

    this.boxType = this.dataset.limespotBoxType;

    if (this.boxType === 'recently-viewed') {
      this.recentlyViewed();
    }
  }

  recentlyViewed() {
    const recentViews = JSON.parse(localStorage.getItem('lsRecentViews'));
    const productsAmount = window.location.pathname.includes('/products/') ? 2 : 1;

    if (!recentViews || recentViews.length < productsAmount) {
      this.style.display = 'none';
    }
  }
}

if(!customElements.get('section-limespot-box')) {
  customElements.define('section-limespot-box', limespotProductsBox);
}
